module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--talk-3d511f37a73c7786d8c9a3b78ff2bd83.png";